import { useState } from "react";
import { allOnPageSelected, deselectAllIds, selectAllIds, toggleId } from "../../../utils/selectionManager";

/**
 * PersonId-keyed row selection, shared by both report pages (By Technology, By Certificates).
 * Built on the same `Set<number>` primitive as CV List's and Employee Overview's selection
 * hooks (ADR-131) — simpler than `useEmployeeSelection` since report rows only ever carry a
 * single PersonId, not the dual Employee/Person id Employee Overview has to track.
 */
export function useReportSelection() {
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());

  const handleToggleSelect = (personId: number) => {
    setSelectedIds((prev) => toggleId(prev, personId));
  };

  const handleSelectAllOnPage = (pagePersonIds: number[]) => {
    setSelectedIds((prev) => selectAllIds(prev, pagePersonIds));
  };

  const handleDeselectAllOnPage = (pagePersonIds: number[]) => {
    setSelectedIds((prev) => deselectAllIds(prev, pagePersonIds));
  };

  const handleClearAll = () => {
    setSelectedIds(new Set());
  };

  return {
    selectedIds,
    allOnPageSelected,
    handleToggleSelect,
    handleSelectAllOnPage,
    handleDeselectAllOnPage,
    handleClearAll,
  };
}
